import Vue from "vue";

import { ModelState } from "@elite/validation";

import App from "./App.vue";
import { configure } from "./config";
import router from "./router";
import store, { AppActionTypes, restClient } from "./store";

Vue.config.productionTip = false;

configure();

const modelState: ModelState = new ModelState();

const provide = { restClient: restClient, modelState: modelState };

// see https://stackoverflow.com/a/53715691/26226
const promises = [
    // if we have an auth cookie, set the user before loading vue. This is is required to get the initial state of the user before routing is initialized.
    store.dispatch(AppActionTypes.getUser),
    // get the settings before loading Vue as this is also required by the router.
    store.dispatch(AppActionTypes.getSettings)
];
Promise.allSettled(promises).finally(() => {
    new Vue({
        router,
        store,
        provide,
        render: h => h(App)
    }).$mount("#app");
});
